import { render } from "./mini.vue?vue&type=template&id=c04e9bda"
import script from "./mini.vue?vue&type=script&lang=js"
export * from "./mini.vue?vue&type=script&lang=js"

import "./mini.vue?vue&type=style&index=0&id=c04e9bda&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__